import { render, staticRenderFns } from "./taskCheckDialog.vue?vue&type=template&id=24983b1b&scoped=true"
import script from "./taskCheckDialog.vue?vue&type=script&lang=js"
export * from "./taskCheckDialog.vue?vue&type=script&lang=js"
import style0 from "./taskCheckDialog.vue?vue&type=style&index=0&id=24983b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24983b1b",
  null
  
)

export default component.exports